import { render, staticRenderFns } from "./ObjectView.vue?vue&type=template&id=ea7d4654&scoped=true&"
import script from "./ObjectView.vue?vue&type=script&lang=js&"
export * from "./ObjectView.vue?vue&type=script&lang=js&"
import style0 from "./ObjectView.vue?vue&type=style&index=0&id=ea7d4654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7d4654",
  null
  
)

export default component.exports